import CertsListSidePanelBody from './CertsListSidePanelBody';

export default CertsListSidePanelBody;
